import React, {MouseEvent, useEffect, useState} from "react";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserMenuModel } from "app/model/ua/user-menu";
import { setCurrentMenu } from "app/reducers/menuSlice";
import Account from "app/components/layout/comp/Account";
import MenuItem from "./comp/MenuItem";
import MegaMenu from "./MegaMenu";
import {clearUserInfo} from "app/reducers/userSlice";
import {AuthContextProps, useAuth} from "react-oidc-context";
import { startLogout } from "app/hooks/useSession";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import { UserInfoModel } from "app/model/ua/user-info";

export default function Header() {
  const auth: AuthContextProps = useAuth();
  const userInfo = useAppSelector(state => state.userInfo.userInfo);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const { menus, flatMenus, rootMenu, currentMenu }: any = useAppSelector(state => state.menus);
  const [showTopMenu, setShowTopMenu] = useState<boolean>(true);
  const [activeMenu, setActiveMenu] = useState<UserMenuModel>();
  const [isSignUpPage, setIsSignUpPage] = useState<boolean>(false);

  /*
   * 예전에는 jQuery 스크립트(public/portal/assets/js/layout.js)가 맡던 것들이다.
   *  - 화면 폭 1450px 미만이면 html 에 folding 클래스(layout.css 가 씀)
   *  - 전체메뉴 열기/닫기. 화면 크기가 바뀌거나 다른 화면으로 가면 닫는다
   *    (메뉴에서 항목을 누르면 화면이 바뀌므로 여기서 닫힌다)
   * 그 스크립트가 하던 나머지 — 빈 #gnb 목록과 없는 요소를 전체메뉴에 복제하던 것 —
   * 은 지금 화면에 대응하는 요소가 없어 옮기지 않았다.
   */
  const [fullOpen, setFullOpen] = useState<boolean>(false);
  useEffect(() => {
    const onResize = () => {
      document.documentElement.classList.toggle('folding', window.innerWidth < 1450);
      setFullOpen(false);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  useEffect(() => { setFullOpen(false); }, [location.key]);
  useEffect(() => {
    document.getElementById('wrap')?.classList.toggle('fullOpen', fullOpen);
    if (fullOpen) {
      document.querySelector<HTMLElement>('#fullMenu .nav button, #fullMenu .nav a')?.focus();
    }
  }, [fullOpen]);

  useEffect(() => {
    if (currentUrl.includes('/sign-up/')) {
      setShowTopMenu(false);
      setIsSignUpPage(true);
    } else {
      setShowTopMenu(true);
      setIsSignUpPage(false);
    }
  }, [currentUrl]);

  useEffect(() => {
    if (rootMenu) {
      setActiveMenu(rootMenu);
    } else {
      const currentMenu = flatMenus.find((menu: UserMenuModel) =>
        menu.menuUrlAddr && currentUrl.startsWith(menu.menuUrlAddr));
      if (currentMenu) {
        let tempArray: UserMenuModel[] = [];
        let currentMenuDepth = currentMenu.depth ?? 0;
        if (currentMenuDepth > 1) {
          tempArray.push(currentMenu);
          for (let i = 0; i < currentMenuDepth - 1; i++) {
            const upperMenuId = tempArray[0].uppoMenuId;
            if (upperMenuId) {
              const upperMenu = flatMenus.find((menu: UserMenuModel) => menu.menuId === upperMenuId);
              if (upperMenu) {
                tempArray.unshift(upperMenu);
              }
            }
          }
          dispatch(setCurrentMenu({currentMenu: currentMenu, rootMenu: tempArray[0]}));
          setActiveMenu(tempArray[0]);
        } else {
          dispatch(setCurrentMenu({currentMenu: currentMenu, rootMenu: currentMenu}));
          setActiveMenu(currentMenu);
        }
      }
    }
  }, [flatMenus, currentUrl, rootMenu]);

  function handleClickMenu(item: UserMenuModel, rootMenu: UserMenuModel) {
    setActiveMenu(rootMenu);
    const hasUrl: boolean = !!item.menuUrlAddr && item.menuUrlAddr !== "";
    const hasChildren: boolean = (item.subMenus?.length ?? 0) > 0;

    if (hasUrl) {
      dispatch(setCurrentMenu({ currentMenu: item, rootMenu: rootMenu }));
      navigate(item.menuUrlAddr!);
    } else if (!hasChildren) {
      dispatch(setCurrentMenu({ currentMenu: item, rootMenu: rootMenu }));
    }
  }

  async function handleClickLogout(e: MouseEvent) {
    e.preventDefault();
    localStorage.clear();
    dispatch(clearUserInfo());
    // 방식에 따라 절차가 다르다. BFF 는 게이트웨이 세션 하나만 끊으면 된다.
    void startLogout(auth);
  }

  const getUserRoleByUserInfo = (user: UserInfoModel) => {
    if (UserInfoUtil.hasRole(user, AuthConstant.ADMIN)) {
      return '관리자';
    } else if (UserInfoUtil.hasRole(user, AuthConstant.R001)) {
      return '산단기업';
    } else if (UserInfoUtil.hasRole(user, AuthConstant.R002)) {
      return '중개업자';
    } else {
      return '사용자';
    }
  };

  return (
    <>
      <header id="header">
        <div className="header-wrap">
          <div className="side-wrap">
            <Link to="/" title="홈 화면으로 이동">
              <h1 className="logo">
                <span className="hid">e-cloud</span>
              </h1>
            </Link>
            <div className="gnb-wrap">
              <div id="gnb">
                <div className="depth01">
                  <ul>
                  </ul>
                </div>
              </div>
            </div>
            <div className="m-logout">
              <Link className="m-logout" to="#" onClick={(e) => handleClickLogout(e)} title="로그아웃">
                <span className="hid">로그아웃</span>
              </Link>
            </div>
            <Link className="fullmenu fullmenuBtn" id="fullmenuOpen" to="#fullMenu" title="전체 메뉴"
                  aria-expanded={fullOpen}
                  onClick={(e) => { e.preventDefault(); setFullOpen(v => !v); }}>
              <em><em><span className="hid">전체메뉴</span></em></em>
            </Link>
          </div>
        </div>

        <div className="hdt-link">
          <div className="ht-tit">
            {
              isSignUpPage
              ?
                <Link to="" title="홈 화면으로 이동" onClick={() => window.location.href = '/'}>
                  <h1 className="logo">
                    <span className="hid">E-cloud</span>
                  </h1>
                </Link>
              :
                <Link to="/" title="홈 화면으로 이동">
                  <h1 className="logo">
                    <span className="hid">E-cloud</span>
                  </h1>
                </Link>
            }
            {/* 25.05.13 권한별 뱃지 추가 */}
            {userInfo && (
              <div className="account-badge">
                <span>{getUserRoleByUserInfo(userInfo)}</span>
              </div>
            )}
          </div>
          <div className="hd-menu">
            <MegaMenu
              visible={showTopMenu}
              menus={menus}
              activeMenu={activeMenu}
              currentMenu={currentMenu}
              showMenuDesc={!userInfo || !UserInfoUtil.hasRole(userInfo, AuthConstant.ADMIN)}
              onClick={handleClickMenu}
            />
          </div>
          <div className="util">
            <Account />
          </div>
        </div>
      </header>
      <div className="popFullmenu" style={{display: fullOpen ? 'block' : 'none'}}>
        <div id="fullMenu">
          <h3 className="hid">전체메뉴</h3>
          <div className="nav">
            <MenuItem lev={1} menus={menus} openActiveMenu={false} />
          </div>
        </div>
      </div>
    </>
  );
}
